import {LonerGameAssets} from "../../../LonerGameAssets";
import {gsap} from "gsap";
import {Loner} from "../../../Loner";
import {LonerSound} from "../../../sound/LonerSound";

export class LonerPinTheWinCornerMulti extends PIXI.Container {
    private _multiplierText: PIXI.BitmapText;
    private _maxWinSprite: PIXI.Sprite;
    private _index: number;
    private _value: number;
    private _isMaxWinBlinking: boolean = false;
    private _maxWinSymbolBlinkTL: gsap.core.Timeline | null;

    constructor(index: number) {
        super();
        this._index = index;
        this.init(index);
        this.addChild(this._maxWinSprite, this._multiplierText);
        this.name = `cornerMulti-${index}`;
    }

    public setMulti(value: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(() => {
            this.setScaleAndPos(value);
            this._value = value;
            this._multiplierText.text = "x";
            this._multiplierText.text += value;
            if (value === 42) {
                this._multiplierText.visible = false;
                this._maxWinSprite.visible = true;
                if (!this._isMaxWinBlinking) {
                    this._maxWinSymbolBlinkTL = gsap.timeline();
                    this._isMaxWinBlinking = true;
                    this.startMaxWinSymbolBlink();
                }
            } else {
                if (this._isMaxWinBlinking) {
                    this.stopMaxWinSymbolBlink();
                }
                this._multiplierText.visible = true;
                this._maxWinSprite.visible = false;
            }
        })
        return tl;
    }

    public hide(duration: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.to([this._multiplierText, this._maxWinSprite], duration, {alpha: 0}, 0);
        tl.add(() => {
            this._multiplierText.visible = false;
            this._maxWinSprite.visible = false;
        })
        return tl;
    }

    public show(duration: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(() => {
            if (this._value === 42) {
                this._maxWinSprite.visible = true;
                this._multiplierText.visible = false;
            } else {
                this._maxWinSprite.visible = false;
                this._multiplierText.visible = true;
            }
        })
        tl.to([this._multiplierText, this._maxWinSprite], duration, {alpha: 1}, 0);

        return tl;
    }

    public stopMaxWinSymbolBlink(): void {
        if (this._isMaxWinBlinking) {
            if (this._maxWinSymbolBlinkTL) {
                this._maxWinSymbolBlinkTL.clear();
                this._maxWinSymbolBlinkTL.kill();
                if (Loner.soundPlayer.player.fetchSoundPlayer(LonerSound.PTW_MAX_WIN_SYM_BLINK)?.isPlaying) {
                    Loner.soundPlayer.stopSound(LonerSound.PTW_MAX_WIN_SYM_BLINK);
                }
                this._maxWinSymbolBlinkTL = null;
            }
            this._isMaxWinBlinking = false;
            return;
        }
    }

    private startMaxWinSymbolBlink(): void {
        if (!this._isMaxWinBlinking) {
            if (this._maxWinSymbolBlinkTL) {
                this._maxWinSymbolBlinkTL.clear()
                this._maxWinSymbolBlinkTL.kill();
                if (Loner.soundPlayer.player.fetchSoundPlayer(LonerSound.PTW_MAX_WIN_SYM_BLINK)?.isPlaying) {
                    Loner.soundPlayer.stopSound(LonerSound.PTW_MAX_WIN_SYM_BLINK);
                }
                this._maxWinSymbolBlinkTL = null;
            }
            return;
        }
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.to(this._maxWinSprite, {alpha: 0.3, duration: 0.25});
        tl.to(this._maxWinSprite, {alpha: 1, duration: 0.25}).add(() => {
            Loner.soundPlayer.playSound(LonerSound.PTW_MAX_WIN_SYM_BLINK);
        });
        tl.to(this._maxWinSprite, {alpha: 0.3, duration: 0.25});
        tl.to(this._maxWinSprite, {alpha: 1, duration: 0.25}).add(() => {
            Loner.soundPlayer.playSound(LonerSound.PTW_MAX_WIN_SYM_BLINK);
        });
        if (this._isMaxWinBlinking) {
            tl.add(() => {
                this.startMaxWinSymbolBlink();
            })
        }
        if (this._maxWinSymbolBlinkTL) {
            this._maxWinSymbolBlinkTL.add(tl);
        }
    }

    private setScaleAndPos(value: number): void {
        if (value < 10) {
            if (this._index === 0) {
                setPos(this._multiplierText, [39, 153], 0.5);
            } else if (this._index === 1) {
                setPos(this._multiplierText, [677, 156], 0.5);
            } else if (this._index === 2) {
                setPos(this._multiplierText, [58, 512], 0.5);
            } else {
                setPos(this._multiplierText, [661, 512], 0.5);
            }
        } else if (value >= 10 && value < 100) {
            if (this._index === 0) {
                setPos(this._multiplierText, [45, 167], 0.5);
            } else if (this._index === 1) {
                setPos(this._multiplierText, [679, 166], 0.5);
            } else if (this._index === 2) {
                setPos(this._multiplierText, [61, 512], 0.5);
            } else {
                setPos(this._multiplierText, [664, 512], 0.5);
            }
        } else if (value >= 100 && value < 1000) {
            if (this._index === 0) {
                setPos(this._multiplierText, [41, 165], 0.45);
            } else if (this._index === 1) {
                setPos(this._multiplierText, [675, 166], 0.45);
            } else if (this._index === 2) {
                setPos(this._multiplierText, [61, 512], 0.45);
            } else {
                setPos(this._multiplierText, [662, 512], 0.45);
            }
        } else {
            if (this._index === 0) {
                setPos(this._multiplierText, [41, 165], 0.37);
            } else if (this._index === 1) {
                setPos(this._multiplierText, [675, 166], 0.37);
            } else if (this._index === 2) {
                setPos(this._multiplierText, [61, 512], 0.37);
            } else {
                setPos(this._multiplierText, [662, 512], 0.37);
            }
        }

        function setPos(multiplier: PIXI.BitmapText, pos: number[], scale: number) {
            multiplier.position.set(pos[0], pos[1]);
            multiplier.scale.set(scale);
        }
    }

    private init(index: number): void {
        this._multiplierText = this.createMultiplier(index);
        this._maxWinSprite = this.createMaxWinSprite(index);
    }

    private createMaxWinSprite(index: number): PIXI.Sprite {
        const sprite = new PIXI.Sprite(Loner.assetLoader.getTextures("SpinSpinSpin/max_win")[0]);
        sprite.anchor = new PIXI.Point(0.5, 0.5);
        sprite.visible = false;
        switch (index) {
            case 0:
                sprite.angle = -45;
                sprite.position.set(53, 174);
                break;
            case 1:
                sprite.angle = 45;
                sprite.position.set(666, 175);
                break;
            case 2:
                sprite.angle = -315;
                sprite.position.set(50, 524);
                break;
            case 3:
                sprite.angle = 315;
                sprite.position.set(671, 523);
                break;
        }
        return sprite;
    }

    private createMultiplier(index: number): PIXI.BitmapText {
        const text = new PIXI.BitmapText("x1", {
            fontName: LonerGameAssets.BITMAP_FONT_PTW,
            fontSize: 24
        });
        text.anchor = new PIXI.Point(0.5, 0.5);
        text.visible = false;
        text.alpha = 0;
        text.scale.set(0.5);
        switch (index) {
            case 0:
                text.angle = -45;
                text.position.set(65, 140);
                break;
            case 1:
                text.angle = 45;
                text.position.set(645, 140);
                break;
            case 2:
                text.angle = -315;
                text.position.set(65, 470);
                break;
            case 3:
                text.angle = 315;
                text.position.set(645, 470);
                break;
        }
        return text;
    }
}